import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';

import './ExchangeExcessContributionMessage.scss';

import { moduleActions } from '../../../redux/modules';
import {
  getExchangeFromTotalDollars,
  getExchangeIRALimitAmount,
} from '../../../redux/modules/exchangeTransaction/exchangeTransaction.selectors';
import { currency } from '../../../utils/utils';
import warningExclaimation from '../../../assets/images/warning-exclaimation.svg';

function ExchangeExcessContributionMessage({
  actions: { setProgress },
  exchangeFromTotalDollars,
  exchangeIRALimitAmount,
}) {
  return (
    <div className="e2e-ira-excess-contribution exchange-excess-contribution-message-IRA-excess-contribution">
      <img
        alt=""
        src={warningExclaimation}
        className="exchange-excess-contribution-message-IRA-excess-contribution-img"
      />
      <div className="exchange-excess-contribution-message-IRA-excess-contribution-content">
        <div className="exchange-excess-contribution-message-header">
          Contribution amount {currency(exchangeFromTotalDollars)} exceeds{' '}
          {currency(exchangeIRALimitAmount)}
          {` `}
          of remaining annual IRA contribution limit.
        </div>
        <div className="exchange-excess-contribution-message-content">
          <a
            onClick={() => setProgress(1)}
            className="exchange-excess-contribution-message-modify-link"
          >
            Modify exchange amount
          </a>{' '}
          to make an IRA contribution.
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    exchangeFromTotalDollars: getExchangeFromTotalDollars(state),
    exchangeIRALimitAmount: getExchangeIRALimitAmount(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(moduleActions, dispatch),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  ExchangeExcessContributionMessage
);
